import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from "@ngx-translate/core";
import { LangsSidebarComponentGeneric } from "./langs-sidebar";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule
    ],
    declarations: [LangsSidebarComponentGeneric],
    exports: [LangsSidebarComponentGeneric]
})
export class LangsSidebarModuleGeneric {}
